// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './vuex/store';
import Papa from 'papaparse'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Axios from 'axios';
import Echarts from 'echarts';
import 'echarts-gl';
import 'babel-polyfill'
import './assets/iconfont/iconfont.css'
import './assets/GlobalCSS/basic.css'
import './assets/GlobalCSS/aside.css'
import App from './App'
import router from './router'
import i18n from './language/language.js';
import DisableArrowToggle from '@/js/directives/disableArrowToggle';

Vue.directive('disable-arrow-toggle', DisableArrowToggle);
Vue.prototype.echarts = Echarts
Vue.prototype.papa = Papa


//接口入口设置
//Vue.use(Axios);
Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/bs'
Axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.config.productionTip = false
Vue.use(ElementUI);
document.addEventListener('contextmenu', e => e.preventDefault());

Axios.interceptors.request.use(config => {
  // 设置动态请求头
  let tempServerTimeOffset = localStorage.getItem('serverTimeOffset')
  if(tempServerTimeOffset != undefined && !isNaN(parseInt(tempServerTimeOffset))) {
    store.commit('setServerTimeOffset', parseInt(tempServerTimeOffset))
  }
  config.headers['Request_id'] = generateUUID()
  config.headers['X_timestamp'] = Date.now() + store.state.serverTimeOffset
  return config
}, error => {
  return Promise.reject(error)
})

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js